import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { MaterialType } from './material-type';
import { MaterialUnit } from './material-unit';
import {ShortObject} from '../../../../../../app-misc/src/app/modules/project-misc/data/project/short-json-object';

@JsonObject('model.cv.MaterialPage')
export class MaterialPage extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'sku')
    sku?: string;

    @JsonProperty(Boolean, 'createdManually')
    createdManually?: boolean;

    @JsonProperty(Boolean, 'isStock')
    isStock?: boolean;

    @JsonProperty(Number, 'bandingRollLength')
    bandingRollLength?: number;

    @JsonProperty(Number, 'minStockQty')
    minStockQty?: number;

    @JsonProperty(Number, 'reorderQty')
    reorderQty?: number;

    @JsonProperty(Number, 'inStockCount')
    inStockCount?: number;

    @JsonProperty(String, 'description')
    description?: string;

    @JsonProperty(Number, 'defaultCost')
    defaultCost: number;

    @JsonProperty(MaterialUnit, 'unitOfIssue')
    unitOfIssue?: MaterialUnit;

    @JsonProperty(ShortObject, 'defaultVendor')
    defaultVendor?: ShortObject;

    @JsonProperty(MaterialType, 'type')
    type?: MaterialType;

    @JsonProperty(String, 'unit')
    unit?: string;

    @JsonProperty(Number, 'sellPrice')
    sellPrice?: number;

    @JsonProperty(Number, 'waste')
    waste: number;

    @JsonProperty(Number, 'defaultMarkup')
    defaultMarkup: number;

    @JsonProperty(Number, 'defaultTaxRate')
    defaultTaxRate: number;

}
